export default "__VITE_ASSET__DZTQx1jG__"